import Component from '../core/Component'
import tippy from 'tippy.js'
import { unescapeHTML } from '../utils/String'
import throttle from 'lodash/throttle'
import { loadComponents, removeComponents } from '../core/componentUtils'

export default class Tooltips extends Component {
    constructor(element) {
        super(element)

        this.tooltips = []
        this.lastGroup = ''
    }

    prepare() {
        document.body.addEventListener('click', this.handleClick)
        document.body.addEventListener('mouseover', this.handleMouseOver)
    }

    destroy() {
        document.body.removeEventListener('click', this.handleClick)
        document.body.removeEventListener('mouseover', this.handleMouseOver)
        this.tooltips.forEach(tooltip => tooltip.destroy())
    }


    handleMouseOver = throttle((event) => {
        const element = event.target.closest('[data-tooltip-content], .tippy-box')
        if (!element) {
            this.hideAll()
            return
        }

        if (element.classList.contains('tippy-box') || element.classList.contains('is-tooltip-open')) {
            return
        }

        this.updateActiveGroup(element)
        this.hideAll()
        this.showTooltip(element)
    }, 300)

    handleClick = (event) => {
        const element = event.target.closest('[data-tooltip-content], .tippy-box')
        if (!element) {
            this.hideAll()
            return
        }

        if (element.classList.contains('tippy-box')) {
            return
        }

        this.updateActiveGroup(element)
        this.hideAll()
        this.showTooltip(element)
    }

    showTooltip(tooltipEl) {
        const getContent = () => {
            const buffer = document.createElement('span')
            buffer.innerHTML = unescapeHTML(tooltipEl.dataset.tooltipContent)
            return buffer
        }
        const getOffset = () => {
            const offset = tooltipEl.dataset.tooltipOffset ? parseInt(tooltipEl.dataset.tooltipOffset) : 0
            return [offset,offset]
        }
        const getTheme = () => {
            return tooltipEl.dataset.tooltipTheme ?? ''
        }
        const getPlacement = () => {
            return tooltipEl.dataset.tooltipPlacement ?? 'top'
        }

        const t = tippy(tooltipEl, {
            triggerTarget: tooltipEl,
            trigger: '',
            content: getContent(),
            offset: getOffset(),
            placement: getPlacement(),
            theme: getTheme(),
            allowHTML: true,
            interactive: true,
            onShown(instance) {
                loadComponents(instance.popper)
                tooltipEl.classList.add('is-tooltip-open')
            },
            onHidden(instance) {
                removeComponents(instance.popper)
                tooltipEl.classList.remove('is-tooltip-open')
            }
        })
        t.__group = tooltipEl.dataset.tooltipGroup ?? ''
        t.show()
        this.tooltips.push(t)
    }

    updateActiveGroup = (element) => {
        this.lastGroup = element?.dataset.tooltipGroup ?? ''
    }

    hideAll() {
        this.tooltips.forEach(tooltip => {
            if (this.lastGroup && tooltip.__group !== this.lastGroup) {
                return
            }
            tooltip.hide()
        })
        if (!this.lastGroup) {
            this.tooltips.length = 0
        }
    }
}